/**
 * Keep free-shipping progress bars in sync on PUB_SUB_EVENTS.cartUpdate.
 * Shipping-protection (custom.js refreshCartUI) only fires cart:updated —
 * bridge that into Dawn's pub/sub so we don't touch custom.js.
 */
(function () {
  var MONEY_FORMAT =
    (window.Shopify && Shopify.money_format) ||
    (window.theme && theme.moneyFormat) ||
    '${{amount}}';

  function formatMoney(cents, format) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format || MONEY_FORMAT);
    }
    var value = (Number(cents) || 0) / 100;
    var fixed = value.toFixed(2);
    var fmt = format || MONEY_FORMAT;
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, fixed.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(value)))
      .replace(/\{\{\s*amount\s*\}\}/g, fixed);
  }

  function updateBar(bar, totalPrice) {
    var threshold = parseInt(bar.getAttribute('data-threshold'), 10);
    if (!threshold || threshold <= 0) return;

    var total = Math.max(0, parseInt(totalPrice, 10) || 0);
    var remaining = Math.max(0, threshold - total);
    var pct = Math.min(100, Math.max(0, (total * 100) / threshold));
    var unlocked = remaining === 0;

    bar.setAttribute('data-cart-total', String(total));
    bar.classList.toggle('free-shipping-bar--unlocked', unlocked);

    var fill = bar.querySelector('.free-shipping-bar__fill');
    if (fill) fill.style.width = pct + '%';

    var message = bar.querySelector('.free-shipping-bar__message');
    if (!message) return;

    if (unlocked) {
      message.textContent =
        bar.getAttribute('data-unlocked-message') || "You've unlocked free shipping";
    } else {
      var moneyFormat = bar.getAttribute('data-money-format') || MONEY_FORMAT;
      var template =
        bar.getAttribute('data-remaining-message') ||
        "Free shipping at <strong>[[threshold]]</strong> — you're <strong>[[amount]]</strong> away";
      var remainingMoney = formatMoney(remaining, moneyFormat);
      var thresholdMoney = formatMoney(threshold, moneyFormat);
      message.innerHTML = template
        .split('[[threshold]]')
        .join(thresholdMoney)
        .split('[[amount]]')
        .join(remainingMoney);
    }
  }

  function updateFromCart(cart) {
    if (!cart || typeof cart.total_price === 'undefined') return;
    var marketTotal =
      typeof window.afterpay_cart_total_price === 'number'
        ? window.afterpay_cart_total_price
        : cart.total_price;
    updateBars(marketTotal);
  }

  function updateBars(totalPrice) {
    document.querySelectorAll('[data-free-shipping-bar]').forEach(function (bar) {
      updateBar(bar, totalPrice);
    });
  }

  window.mtUpdateFreeShippingBars = updateBars;

  function onCartUpdate(payload) {
    var cart = payload && payload.cartData;
    if (cart && typeof cart.total_price !== 'undefined') {
      updateFromCart(cart);
      return;
    }
    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(updateFromCart)
      .catch(function () { });
  }

  function bridgeCustomCartEvent(event) {
    var detail = (event && event.detail) || {};
    var cart = detail.cart;
    if (!cart) return;

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: detail.source || 'cart-refresh',
        cartData: cart,
      });
      return;
    }

    updateFromCart(cart);
  }

  // Only bridge cart:updated (refreshCartUI also fires cart:refresh — avoid double publish).
  document.addEventListener('cart:updated', bridgeCustomCartEvent);
  subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
})();
